class ShareButton {
  constructor(el) {
    this.dom = {el: el};
    this.dom.trigger = this.dom.el.querySelector('[data-js="share-trigger"]');
    this.dom.contents = this.dom.el.querySelector('[data-js="share-contents"]');

    this.show = this.show.bind(this);

    this.init();
  }

  init() {
    this.dom.trigger.addEventListener('click', this.show);
  }

  show() {
    if (this.dom.contents.dataset.is !== 'show') {
      this.dom.contents.dataset.is = 'show';
    } else {
      this.dom.contents.removeAttribute('data-is');
    }
  }
}

export default ShareButton